<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M5.93 9.16q0-.79.53-1.43.56-.64 1.4-.67.04.5-.2 1-.25.52-.71.84t-1.02.26m3.84 4.81q-.15.53-.49 1.11-.35.6-.8 1.05-.12.12-.34.22-.2.08-.46.08-.23 0-.41-.07l-.38-.15-.32-.11a1 1 0 0 0-.42-.07q-.5 0-.82.2-.3.22-.73.21-.5 0-1.13-.69-.58-.67-.96-1.64a5 5 0 0 1-.36-1.88q0-.55.15-1.07.18-.53.52-.96.63-.8 1.72-.8.51 0 .85.22.33.2.6.2.32 0 .72-.21.4-.23 1.04-.23 1.19 0 1.8.9a2 2 0 0 0-.59.52 2.5 2.5 0 0 0-.42 1.27 2 2 0 0 0 .16.82q.15.37.4.64.27.26.67.44m3.8-6.23v1.64h1.34v1.12h-1.33v3.86q0 .88.83.88h.26q.17-.02.21-.05v1.19l-.32.04-.46.01q-1.06 0-1.52-.43t-.45-1.47V10.5h-1V9.38h1V7.74zm6.05 8.64h-1.5l-2.57-7h1.53l1.8 5.62 1.7-5.62h1.57z"
      />
    </svg>
  </span>
</template>
